<template>
  <vs-popup
    class="holamundo"
    :title="'Histórico Status'"
    :active.sync="popupHistorico"
    @close="popupHistorico = false"
  >
    <div v-if="dados.historico.length && !carregando">
      <table class="table table-bordered">
        <tr>
          <th class="uppercase">Código da Proposta</th>
          <td>{{ dados.idProposta }}</td>
        </tr>

        <tr>
          <th class="uppercase">Qtd Alteração Status</th>
          <td>{{ dados.historico.length }}</td>
        </tr>
      </table>

      <hr class="my-2" />

      <h5 class="my-2">Permanência Status</h5>

      <div
        class="grid grid-cols-12 mt-4 border border-t-2"
        v-for="item in dados.historico"
        :key="item.id"
      >
        <div class="col-span-1 flex justify-center items-center text-right">
          #{{ item.id }}
        </div>

        <div class="col-span-4 flex justify-start items-center">
          <vs-chip
            :color="getStatusColor(item.nomeStatus)"
            class="product-order-status font-bold"
            >{{ item.nomeStatus }}
          </vs-chip>
        </div>

        <div class="col-span-4 flex justify-start items-center">
          {{ item.intervalo }}
        </div>
      </div>
    </div>

    <div v-else-if="!dados.historico.length && !carregando">
      <h5 class="my-2">Nenhum histórico encontrado</h5>
    </div>
  </vs-popup>
</template>

<script>
import service from '../../services';
import functions from '../../utils/functions';
import moment from 'moment';

export default {
  name: 'ModalHistorico',

  props: ['dadosHistorico'],

  data() {
    return {
      carregando: true,
      popupHistorico: false,
      dados: {
        idProposta: 0,
        historico: [],
      },
    };
  },

  watch: {
    dadosHistorico() {
      this.preencheModal();
    },
  },

  methods: {
    preencheModal() {
      if (this.dadosHistorico.id) {
        this.carregando = true;
        this.$vs.loading();
        this.popupHistorico = true;
        this.dados.historico = [];

        service
          .post('Cotacao', 'buscar-historico-alteracao-status', {
            idProposta: this.dadosHistorico.id,
          })
          .then(({ data }) => {
            const resultado = [];

            if (data.length) {
              for (let i = 0; i < data.length - 1; i++) {
                const obj = {};
                obj.id = i + 1;
                obj.nomeStatus = data[i].nomeStatus;
                obj.intervalo = this.calculaQtdDias(
                  data[i + 1].createdAt,
                  data[i].createdAt,
                  data[i].nomeStatus,
                );

                resultado.push(obj);
              }
            }

            // validação da última linha (se status === finalizado)
            const intervalo = this.calculaQtdDias(
              Date.now(),
              this.dadosHistorico.data,
              this.dadosHistorico.nomeStatus,
            );

            resultado.push({
              id: data.length || 1,
              nomeStatus: this.dadosHistorico.nomeStatus,
              intervalo: intervalo,
            });

            this.dados.idProposta = this.dadosHistorico.id;
            this.dados.historico = resultado;

            this.$vs.loading.close();
            this.carregando = false;
          })
          .catch((erro) => {
            console.error('Erro ao preencher dados do histórico:', erro);
          });
      }
    },

    calculaQtdDias(dataInicio, dataFim, nomeStatus) {
      if (nomeStatus === 'Finalizada')
        return moment(dataFim).format('DD/MM/YYYY HH:mm:ss');

      const ms = moment(dataInicio).diff(moment(dataFim));
      return functions.formataMsParaData(ms);
    },

    getStatusColor(date) {
      return functions.getStatusColor(date);
    },
  },
};
</script>
